// For localised sort option labels in React components, use the useOfferListSortOptions hook (hooks/useOfferListSortOptions).
// These constants are retained for non-React consumers that only need .value (e.g. state initializers, analytics).

export const SORT_OPTION_NEW_HOME_PAGE = {
  label: 'Recommended',
  value: 'home',
} as const

export const SORT_OPTION_HOME_PAGE = {
  label: 'Recommended',
  value: 'homepage',
} as const

export const SORT_OPTION_RECOMMENDED = {
  label: 'Recommended',
  value: 'recommended',
} as const

export interface OfferListSortOption {
  label: string
  value: string
}
